<template>
  <div>
    <MediaLoader v-if="mediaLoader" height="100%" :width="mediaWidth"/>
    <div>
      <header class="cover b-white">
        <div class="pt-5">
          <div class="row">
            <div class="col-md-9 p-0">
              <div class="ml-4 px-5">
                <b-breadcrumb :items="items" class="bg-transparent p-0"/>
                <h2 class="font-weight-light">
                  {{curse ? curse.title : ''}}
                </h2>
              </div>
              <div class="bg-media">
                <CourseEvaluation
                  v-if="viewEvaluateCourse"
                  :height="mediaHeight"
                  :width="mediaWidth"
                  :stars="stars"
                  :course_id="course_info.id"
                />
                <Media
                  :kind="'video'"
                  ref="mediaVideo"
                  @ended="endVideo"
                  :controls="true"
                  :autoplay="this.play.autoplay"
                  :src="[this.play.video ? this.play.video : '']"
                  :poster="this.play.cover ? this.play.cover : 'https://peach.blender.org/wp-content/uploads/title_anouncement.jpg?x11217'"
                  :class="'row rounded mt-4 shadow-sm embed-responsive embed-responsive-16by9 media-video'"
                />
                <div
                  v-if="!viewEvaluateCourse && stars == 0 && !mediaLoader && viewEvaluateCard"
                  class="card-msg-evaluation"
                  style
                >
                  <b-card class="text-left" @click="viewEvaluateCourse=true">
                    <div class="text-dark">
                      <b-row>
                        <b-col class="text-center">
                          <i style="font-size:34px" class="text-warning fas fa-star"/>
                        </b-col>
                        <b-col cols="10">
                          <p>
                          <h4>Evaluar Curso</h4>
                          <strong>
                            ¡Estamos seguros que este curso te ha ayudado bastante!
                            <br/>Ayúdanos a evaluarlo y hazle saber a los demás tu experiencia.
                          </strong>
                          </p>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card>
                </div>
              </div>

              <div class="col-lg-12">
                <div>
                  <b-tabs style="background:white" fill>
                    <b-tab>
                      <template v-slot:title>
                        <h5 class="fas fa-info-circle font-gray-dark"/> <span
                        class="font-gray-dark font-weight-bold">Descripción</span>
                      </template>
                      <div class="row">
                        <div class="col-lg-12 p-5 ">
                          <h5 class="font-blue font-weight-bold">
                            <i class="fas fa-info"/>
                            Descripción de curso
                          </h5>
                          <p class="text-dark">{{curse.description}}</p>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab active class="p-4" v-if="curse">
                      <template v-slot:title>
                        <h5 class="fas fa-comments font-gray-dark"/> <span class="font-gray-dark font-weight-bold">Preguntas y respuestas</span>
                      </template>
                      <ListQuestions :questions="curse.questions" :course="curse"/>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>
            <!--<div class="col-md-3 b-gray-light px-2 rounded">
              <div class="row">
                <PlayListVideo :videos="curse ? curse.videos : ''"/>
              </div>
            </div>-->
          </div>
        </div>
      </header>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @media only screen and (min-width: 1200px) {
    .media-video {
      height: 620px;
    }
    .bg-media {
      background: #000;
    }
  }
</style>
<script>
  import PlayListVideo from "./components/content/PlayListVideo";
  import Comments from "./components/content/Comments";
  import NewComment from "./components/content/CreateComment";
  import ListQuestions from "./components/content/ListQuestions";
  import CourseEvaluation from "./components/content/CourseEvaluation";
  import MediaLoader from "./components/content/MediaLoader";

  export default {
    components: {
      PlayListVideo: PlayListVideo,
      Comments: Comments,
      NewComment: NewComment,
      ListQuestions,
      CourseEvaluation,
      MediaLoader
    },
    data() {
      return {
        mediaLoader: true,
        mediaHeight: null,
        mediaWidth: null,
        viewEvaluateCourse: false,
        viewEvaluateCard: false,
        stars: 1,
        curse: {},
        course_info: null,
        commented: true,
        questions: [],
        play: {
          cover: null,
          video: null,
          autoplay: false,
          description: null
        },
        items: [
          {
            text: "Cursos",
            href: "/curses"
          },
          {
            text: "",
            href: ""
          },
          {
            text: "Lista de Reproducción",
            active: true
          }
        ]
      };
    },
    methods: {
      getCurseAndVideos() {
        let url_public = this.$route.params.url_public;
        this.api
          .get("curse/content/" + url_public)
          .then(({data}) => {
            this.curse = data.body;
            this.getCourseInfo();
            if (data.body.commented) {
              this.commented = false;
            }

            //breadcrumb
            this.items[1].text = this.curse.title;
            this.items[1].href = "/curse/view/" + this.curse.url_public;

            //defaultVideo
            this.play.cover = this.curse.videos[0].cover;
            this.play.video = this.curse.videos[0].video;
            this.play.description = this.curse.videos[0].description;
          })
          .catch(err => {
            console.log(err);
          });
      },
      getCourseInfo() {
        let url = "course/" + this.curse.id + "?questions=true";
        this.api
          .get(url)
          .then(({data}) => {
            this.mediaLoader = false;
            this.questions = data.questions;
            this.course_info = data;
            this.validatePayment(data);
            this.validateRating(data);
          })
          .catch(err => {
            console.log(err);
          });
      },
      validateRating(course) {
        let rating_user = course.rating.filter(evaluation => {
          return evaluation.user.id == course.user.id;
        });
        if (rating_user.length > 0) {
          this.stars = rating_user[0].star;
        } else {
          this.stars = 0;
        }
      },
      loadVideo(cover, video, description) {
        this.play.cover = cover;
        this.play.video = video;
        this.play.description = description;
        this.play.autoplay = true;
      },
      validatePayment(data) {
        if (!data.course_payment && !data.trainer_owner) {
          this.$router.push({
            name: "paymentCourse",
            params: {
              CourseInfo: data
            }
          });
        }
      },
      getMediaSizes() {
        this.mediaHeight = this.$refs.mediaVideo.clientHeight + "px";
        this.mediaWidth = this.$refs.mediaVideo.clientWidth + "px";
      },
      endVideo() {
        this.viewEvaluateCard = true;
      }
    },
    computed: {},
    created() {
      this.getCurseAndVideos();
      this.bus.$on("UpdateQuestions", questions => {
        this.questions = questions;
      });
      this.bus.$on("EvaluateCourse", stars => {
        this.viewEvaluateCourse = false;
        this.stars = stars;
      });
      this.bus.$on("CloseEvaluate", data => {
        this.viewEvaluateCourse = false;
      });
    },
    mounted() {
      this.getMediaSizes();
      window.onresize = event => {
        this.getMediaSizes();
      };
    }
  };
</script>

<style>
  .card-msg-evaluation {
    margin-top: -250px;
    z-index: 999;
    position: absolute;
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/#public/curse/CurseContent.vue